import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {Scene} from '../../../ui_html/UISceneTypes'
import {UIDAboutSceneController} from './UIDAboutSceneController'
import {UIDCareersSceneController} from './UIDCareersSceneController'
import {UIDCommunitySceneController} from './UIDCommunitySceneController'
import {UIDFAQSceneController} from './UIDFAQSceneController'
import {UIDGiftingSceneController} from './UIDGiftingSceneController'
import {UIDLeaderboardSceneController} from './UIDLeaderboardSceneController'
import {UIDPatchNotesSceneController} from './UIDPatchNotesSceneController'
import {UIDPrivacyPolicySceneController} from './UIDPrivacyPolicySceneController'
import {UIDStoreSceneController} from './UIDStoreSceneController'
import {UIDProfileSceneController} from './UIDProfileSceneController'
import {UIDValuesSceneController} from './UIDValuesSceneController'
import {UIDTermsSceneController} from './UIDTermsSceneController'
import {UIDPressKitSceneController} from './UIDPressKitSceneController'
import {UIDRefundPolicySceneController} from './UIDRefundPolicyController'
import {UIDReplaySceneController} from './UIDReplaySceneController'
import {UIDChampionship25SceneController} from './UIDChampionship25SceneController'
import {UISidebarController} from '../../../ui_html/sidebar/UISidebarController'

export class UIDiscordSceneController {
    readonly discordLeaderboardController: UIDLeaderboardSceneController
    readonly discordStoreController: UIDStoreSceneController
    private readonly discordAboutController: UIDAboutSceneController
    private readonly discordCareersController: UIDCareersSceneController
    private readonly discordChampionship25Controller: UIDChampionship25SceneController
    private readonly discordCommunityController: UIDCommunitySceneController
    private readonly discordFAQController: UIDFAQSceneController
    private readonly discordPrivacyPolicyController: UIDPrivacyPolicySceneController
    private readonly discordPatchNotesController: UIDPatchNotesSceneController
    readonly discordProfileController: UIDProfileSceneController
    private readonly discordGiftingController: UIDGiftingSceneController
    private readonly discordValuesController: UIDValuesSceneController
    private readonly discordTermsController: UIDTermsSceneController
    private readonly discordPressKitController: UIDPressKitSceneController
    private readonly discordRefundPolicyController: UIDRefundPolicySceneController
    readonly discordReplayController: UIDReplaySceneController

    constructor(sidebar: UISidebarController) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        this.discordLeaderboardController = new UIDLeaderboardSceneController(sidebar)
        this.discordStoreController = new UIDStoreSceneController(sidebar)
        this.discordAboutController = new UIDAboutSceneController(sidebar)
        this.discordCareersController = new UIDCareersSceneController(sidebar)
        this.discordChampionship25Controller = new UIDChampionship25SceneController(sidebar)
        this.discordCommunityController = new UIDCommunitySceneController(sidebar)
        this.discordFAQController = new UIDFAQSceneController(sidebar)
        this.discordPrivacyPolicyController = new UIDPrivacyPolicySceneController(sidebar)
        this.discordPatchNotesController = new UIDPatchNotesSceneController(sidebar)
        this.discordProfileController = new UIDProfileSceneController(sidebar)
        this.discordGiftingController = new UIDGiftingSceneController(sidebar)
        this.discordValuesController = new UIDValuesSceneController(sidebar)
        this.discordTermsController = new UIDTermsSceneController(sidebar)
        this.discordPressKitController = new UIDPressKitSceneController(sidebar)
        this.discordRefundPolicyController = new UIDRefundPolicySceneController(sidebar)
        this.discordReplayController = new UIDReplaySceneController()
    }

    showScene(scene: Scene, hash?: string, value?: string) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        switch(scene) {
            case Scene.DiscordLeaderboard: void this.discordLeaderboardController.show(); break
            case Scene.DiscordStore: this.discordStoreController.show(hash, value); break
            case Scene.DiscordAbout: this.discordAboutController.show(); break
            case Scene.DiscordCareers: this.discordCareersController.show(); break
            case Scene.DiscordChampionship25: this.discordChampionship25Controller.show(); break
            case Scene.DiscordCommunity: this.discordCommunityController.show(); break
            case Scene.DiscordFAQ: this.discordFAQController.show(); break
            case Scene.DiscordPrivacyPolicy: this.discordPrivacyPolicyController.show(); break
            case Scene.DiscordPatchNotes: this.discordPatchNotesController.show(); break
            case Scene.DiscordProfile: this.discordProfileController.show(); break
            case Scene.DiscordGifting: this.discordGiftingController.show(); break
            case Scene.DiscordValues: this.discordValuesController.show(); break
            case Scene.DiscordTerms: this.discordTermsController.show(); break
            case Scene.DiscordPressKit: this.discordPressKitController.show(); break
            case Scene.DiscordRefundPolicy: this.discordRefundPolicyController.show(); break
            default: throw new Error('Invalid scene')
        }
    }

    hideAllScenes() {
        if(!UIUtilsEjsVariables.isUserOnDiscord) return

        this.discordLeaderboardController.hide()
        this.discordStoreController.hide()
        this.discordAboutController.hide()
        this.discordCareersController.hide()
        this.discordChampionship25Controller.hide()
        this.discordCommunityController.hide()
        this.discordFAQController.hide()
        this.discordPrivacyPolicyController.hide()
        this.discordPatchNotesController.hide()
        this.discordProfileController.hide()
        this.discordGiftingController.hide()
        this.discordValuesController.hide()
        this.discordTermsController.hide()
        this.discordPressKitController.hide()
        this.discordRefundPolicyController.hide()
    }
}
